// @ts-nocheck
import React, { useState } from 'react';
import {
    Button, CssBaseline, Backdrop, Fab, Typography, DialogContent as ModalContent,
    DialogActions as ModalActions, TextField, Box
} from '@mui/material';
import { ThemeProvider, StyledEngineProvider, styled } from '@mui/material/styles';
import { useForm, FormProvider } from "react-hook-form";
import Header from "./Header/Header";
import Menu from "./Body/Menu";
import Body from "./Body/Body";
import { ProvideBody } from './Body/state/ProvideBody';
import { ModalGeneral } from "./Componentes/ModalGeneral";
import AlertMessage from "./Alias/AlertMessage";
import { URL_API_SIA, HP_medrano } from "./Contantes/Constantes";
import { setupInterceptorsTo } from "./Componentes/API/AxiosBuilder";
import axios from "axios";
import { useAuth } from "./Auth/State/AuthContext";
import Keycloak from "./Auth/Keycloak";
import SinapThemev2 from "./styles/SinapThemev2";
import PaginaDeCargaGif from "./Componentes/PaginaDeCargaGif";

import SinapTheme from "./styles/SinapTheme";
import ChatBotIncidencias from "./ChatBot/ChatBot";
import { ChatBotIcono } from "./Body/Menu/IconosMenu";
export const TextFieldRojo = styled(TextField)({
    '& label.Mui-focused': {
        color: SinapTheme.palette.primary.main,
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: SinapTheme.palette.primary.main,
    },
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
            borderColor: SinapTheme.palette.primary.main,
        },
    },
});

const ChatbotContainer = styled(Box)(({ theme }) => ({
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 1000,
    width: '350px',
    height: '500px',
    boxShadow: theme.shadows[5],
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
}));

const App = () => {
    const [showChatbot, setShowChatbot] = useState(false);

    const toggleChatbot = () => setShowChatbot(prev => !prev);

    const [openBug, setOpenBug] = useState(false);
    const [openMenu, setOpenMenu] = React.useState(false);
    const { user, isLogedIn, loading } = useAuth();
    const handleCloseBug = () => setOpenBug(false);

    const { register, handleSubmit } = useForm();
    const [bug, setBug] = useState({ codigo: null, description: null });
    const [alertaSubmite, setAlertaSubmite] = useState(null);
    const axiosInstance = setupInterceptorsTo(axios.create({}));

    const toggleDrawer = () => setOpenMenu(!openMenu);

    const handleText = (event) => {
        setBug({
            ...bug,
            [event.currentTarget.name]: event.currentTarget.value
        });
    };

    const onSubmit = async () => {
        try {
            const response = await axiosInstance.post(URL_API_SIA + "/os/crear/ticket", {
                alert: true,
                autorespond: true,
                source: "API",
                name: user.name,
                topicId: HP_medrano,
                email: user.email,
                phone: null,
                attachments: [],
                subject: "Reporte de bug SIA. Codigo: " + bug.codigo,
                message: `Se ha detectado el un bug con el codigo: ${bug.codigo} de SIA. <br>Breve descripcion: ${bug.description}`,
            });

            if ([200, 201].includes(response.status)) {
                setAlertaSubmite({
                    status: "success",
                    message: "Se generó el ticket correctamente, lo estaremos asistiendo por correo"
                });
            } else {
                setAlertaSubmite({
                    status: response.data.severity,
                    message: response.data.status
                });
            }
        } catch (error) {
            setAlertaSubmite({
                status: error.response?.data?.severity || 'error',
                message: error.response?.data?.status || 'Error desconocido al enviar el ticket.'
            });
        }
    };

    const validarDescripcion = () => {
        if (bug.codigo && bug.description) {
            onSubmit();
        } else {
            setAlertaSubmite({ status: 'error', message: 'Debe completar el código y la descripción del error' });
        }
    };

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={SinapThemev2}>
                <CssBaseline />
                <div style={{ display: 'flex' }}>
                    <ProvideBody>
                        {Keycloak.isLoggedIn() && isLogedIn && (
                            <Menu openMenu={openMenu} toggleDrawer={toggleDrawer} />
                        )}
                        <Header error={false} toggleDrawer={toggleDrawer} />
                        {Keycloak.isLoggedIn() && loading ?
                            <PaginaDeCargaGif /> : <Body />
                        }
                    </ProvideBody>
                    {showChatbot && (
                        <ChatbotContainer>
                            <ChatBotIncidencias isAuthenticated={Keycloak.isLoggedIn()} onClose={toggleChatbot} />
                        </ChatbotContainer>
                    )}
                </div>
                
                {!showChatbot && (
                        <Fab
                            color="secondary"
                            aria-label="chat"
                            sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 1001 }}
                            onClick={toggleChatbot}
                        >
                            <ChatBotIcono />
                        </Fab>
                    )
                }

                <ModalGeneral
                    open={openBug}
                    heightAuto
                    onClose={handleCloseBug}
                    titulo="Reportar Error"
                    subtitulo="Genere un ticket sobre el código de error mostrado en pantalla"
                    Contenido={
                        <>
                            <AlertMessage alert={alertaSubmite} setAlert={setAlertaSubmite} />
                            <FormProvider {...{ register }}>
                                <form onSubmit={handleSubmit(() => { })}>
                                    <ModalContent>
                                        {isLogedIn() && (
                                            <Typography variant="body1" gutterBottom>
                                                Usuario Reportante: {user.name}
                                            </Typography>
                                        )}
                                        <TextFieldRojo
                                            value={bug.codigo}
                                            id="bug-codigo"
                                            label="Código numérico del error"
                                            name="codigo"
                                            fullWidth
                                            onChange={handleText}
                                            required
                                            placeholder="Ingrese el código del error encontrado (número de 5 dígitos)"
                                            variant="outlined"
                                            margin="normal"
                                        />
                                        <TextFieldRojo
                                            value={bug.description}
                                            id="bug-description"
                                            label="Descripción del Error"
                                            name="description"
                                            fullWidth
                                            onChange={handleText}
                                            required
                                            placeholder="Ingrese una descripción de cómo ocurrió el error"
                                            multiline
                                            variant="outlined"
                                            margin="normal"
                                            rows={4}
                                        />
                                    </ModalContent>
                                    <ModalActions>
                                        <Button
                                            variant="contained"
                                            onClick={validarDescripcion}
                                            disabled={!bug.codigo || !bug.description}
                                        >
                                            Enviar
                                        </Button>
                                    </ModalActions>
                                </form>
                            </FormProvider>
                        </>
                    }
                />
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
